import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EyeOff } from 'lucide-react';
import { ListingStatus } from '../../types';

/**
 * Top of a listing's public page when it isn't published (plan 16, preview):
 * only owners and the super admin get here; visitors get "not found".
 */
export default function PreviewBanner({
  listingId,
  status,
  rejectionReason,
}: {
  listingId: string;
  status: ListingStatus;
  rejectionReason?: string;
}) {
  const { t } = useTranslation();
  const reason = status === 'rejected' ? rejectionReason?.trim() : '';
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-[16px] border-2 border-dashed border-gold-700/60 bg-gold-50 px-4 py-3 text-ink"
    >
      <EyeOff className="w-5 h-5 mt-0.5 shrink-0 text-gold-700" aria-hidden />
      <div className="min-w-0 space-y-1 text-sm">
        <p className="font-semibold">{t('directory.preview.title')}</p>
        <p>{t('directory.preview.whoSees')}</p>
        <p>
          <span className="font-medium">{t('directory.preview.statusLabel')}</span>{' '}
          {t(`directory.preview.status.${status}`)}
        </p>
        {reason && <p>{t('directory.preview.reason', { reason })}</p>}
        <Link
          to={`/admin?item=${encodeURIComponent(listingId)}`}
          className="inline-flex items-center min-h-[44px] font-medium underline"
        >
          {t('directory.preview.backToEdit')}
        </Link>
      </div>
    </div>
  );
}
